var map = {
	"./birthday.jpg": "2cb6",
	"./birthday_bike_holiday.jpg": "7c30",
	"./italy.jpg": "8505",
	"./love-red.jpg": "2e2d",
	"./mr-mw.jpg": "86ef",
	"./romance-love.jpg": "7a56",
	"./time-to-relax.jpg": "742d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fe";